module.exports = __webpack_public_path__ + "img/num_18.555e9454.png";